import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { filter, map, pipe } from 'rxjs';

import { isValidApiConfig } from 'app/shared/utils';

import { apiConfigFeatureKey, ApiConfigState } from './api-config.reducer';

export const selectApiConfigState = createFeatureSelector<ApiConfigState>(apiConfigFeatureKey);

export const selectApiVersion = createSelector(selectApiConfigState, (state) => state.apiVersion);

export const selectIdentifier = createSelector(selectApiConfigState, (state) => state.identifier);

export const selectRegisterApiConfigProgress = createSelector(
    selectApiConfigState,
    (state) => state.registerProgress,
);

export const selectIsApiConfigValidIfLoaded = pipe(
    select(selectApiConfigState),
    filter((state) => state.preloadProgress.done),
    map(({ apiVersion, identifier }) => isValidApiConfig({ apiVersion, identifier })),
);
